import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTripalArrowForword = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 13,
	viewBox: "0 0 25 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M25 6.5L18.5 0H16L22.5 6.5L16 13H18.5L25 6.5Z",
			fill: "#646464"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 6.5L10.5 0H8L14.5 6.5L8 13H10.5L17 6.5Z",
			fill: "#646464",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 6.5L2.5 0H0L6.5 6.5L0 13H2.5L9 6.5Z",
			fill: "#646464",
			fillOpacity: .3
		})
	]
});
export default SvgTripalArrowForword;
